import React, { createContext, useContext, useEffect, useState } from "react";
import {
  CREDIT_RATING_REPORT_API,
  CREDIT_RATING_FILTERS_API,
} from "../config/apiConfig";
import { securedFetch } from "../utils/api";

const CreditRatingContext = createContext();

export const CreditRatingProvider = ({ children }) => {
  const [selectedReportDate, setSelectedReportDate] = useState(null);

  const [creditRatingFilters, setCreditRatingFilters] = useState(null);
  const [creditRatingFiltersLoading, setCreditRatingFiltersLoading] =
    useState(false);
  const [creditRatingFiltersError, setCreditRatingFiltersError] =
    useState(null);

  const [creditRatingData, setCreditRatingData] = useState([]);
  const [creditRatingDataLoading, setCreditRatingDataLoading] = useState(false);
  const [creditRatingDataError, setCreditRatingDataError] = useState(null);

  useEffect(() => {
    setCreditRatingFiltersLoading(true);
    setCreditRatingFiltersError(null);
    securedFetch(CREDIT_RATING_FILTERS_API, {
      method: "GET",
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch Credit Rating filters data");
        }
        return res.json();
      })
      .then((data) => {
        setCreditRatingFilters(data);
      })
      .catch((error) => {
        setCreditRatingFiltersError(error.message);
      })
      .finally(() => {
        setCreditRatingFiltersLoading(false);
      });
  }, []);

  useEffect(() => {
    if (selectedReportDate) {
      setCreditRatingDataLoading(true);
      setCreditRatingDataError(null);
      securedFetch(CREDIT_RATING_REPORT_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          reportDate: selectedReportDate?.format("YYYY-MM-DD"),
        }),
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Failed to fetch Credit Rating report data");
          }
          return res.json();
        })
        .then((data) => {
          setCreditRatingData(data);
        })
        .catch((error) => {
          setCreditRatingDataError(error.message);
        })
        .finally(() => {
          setCreditRatingDataLoading(false);
        });
    }
  }, [selectedReportDate]);

  return (
    <CreditRatingContext.Provider
      value={{
        creditRatingFilters,
        setCreditRatingFilters,

        creditRatingFiltersLoading,
        setCreditRatingFiltersLoading,

        creditRatingFiltersError,
        setCreditRatingFiltersError,

        selectedReportDate,
        setSelectedReportDate,

        creditRatingData,
        setCreditRatingData,

        creditRatingDataLoading,
        setCreditRatingDataLoading,

        creditRatingDataError,
        setCreditRatingDataError,
      }}
    >
      {children}
    </CreditRatingContext.Provider>
  );
};

export const useCreditRatingContext = () => useContext(CreditRatingContext);
